import React from 'react';
import PropTypes from 'prop-types';
import GoogleAnalytics from "react-ga";
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { Title } from '../RoundResults/RoundResults.styled';
import {
  GameOverDefList,
  GameOverStyled,
  GameOverText,
  GameOverDD,
  GameOverDT,
} from './GameOver.styled';
import EndGameOptions from '../../molecules/EndGameOptions/EndGameOptions';
import ResultIcon from '../../atoms/ResultIcon/ResultIcon';
import { splitAndSpanString } from '../../../helpers/splitAndSpanString';
import { ShareButtonWrap } from '../../atoms/ShareButton/ShareButton.styled';
import ShareButton from '../../atoms/ShareButton/ShareButton';

const mapStateToProps = state => ({
  moveCount: state.game.moveCount,
  level: state.saved.level,
});

const GameOver = ({ show, moveCount, level }) => (
  <CSSTransition in={show} appear timeout={500} classNames="result">
    <section className="result">
      <GameOverStyled gameOver show={show}>
        <ResultIcon win={false} />
        <Title>{splitAndSpanString('Game Over!')}</Title>
        <GameOverText>You ran out of time</GameOverText>
        <GameOverDefList>
          <GameOverDT>Moves:</GameOverDT>
          <GameOverDD>{moveCount}</GameOverDD>
        </GameOverDefList>
        <ShareButtonWrap>
          <ShareButton type="twitter" result={{ level }} />
          <ShareButton type="facebook" />
        </ShareButtonWrap>
        <EndGameOptions roundWin={false} show={show} />
      </GameOverStyled>
      {GoogleAnalytics.event({
        category: 'Gameplay',
        action: `Game Over reached: ${level + 1}`,
        label: `Level reached:`,
        value: level + 1,
      })}
    </section>
  </CSSTransition>
);

export default connect(mapStateToProps)(GameOver);

GameOver.propTypes = {
  show: PropTypes.bool,
  level: PropTypes.number.isRequired,
  moveCount: PropTypes.number.isRequired,
};

GameOver.defaultProps = {
  show: false,
};



// WEBPACK FOOTER //
// ./src/components/organisms/GameOver/GameOver.js